import React, { useEffect, useState, } from 'react'
import { AttendanceTable, Loader } from '../components'
import { getRequest } from '../utils/APICall'
import { useDispatch, useSelector } from 'react-redux'
import { depatmentList, employeeList } from '../redux/employeeSlice'

const TodayAttendence = () => {
    const dipatch = useDispatch()
    const { allEmployee } = useSelector((state) => state.employees || {})
    const { users } = useSelector((state) => state.user || {})
    const [loading, setLoading] = useState(true);
    const fetchAttendance = async () => {
        try {
            const response = await getRequest(`${users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant" || users?.ROLE_TITLE == "Supervisor"  || users?.ROLE_TITLE == "Manager"? "todayAtt" : "todayAtt?departmentcode=5"}`)
            // console.log("response -->>>", response)
            function removeDuplicatesByID(array) {
                const seen = new Set();
                return array.filter((item) => {
                    if (seen.has(item.ID)) {
                        return false; 
                    }
                    seen.add(item.ID);
                    return true; 
                });
            }
            const filterData = removeDuplicatesByID(response.data)
            // console.log("Filter Data", removeDuplicatesByID(response.data))
            dipatch(employeeList(filterData))
        } catch (error) {
            console.log(error)
        }
    }
    // const fetchAttendance = async () => {
    //     setLoading(true);
    //     try {
    //         const response = await getRequest(
    //             users?.ROLE_TITLE === "HR" ||
    //                 users?.ROLE_TITLE === "Admin" ||
    //                 users?.ROLE_TITLE === "Accountant"
    //                 ? "todayAtt"
    //                 : "todayAtt?departmentcode=5"
    //         );

    //         if (response?.success && Array.isArray(response?.data)) {
    //             const seen = new Set();
    //             const filterData = response.data.filter(item => {
    //                 if (seen.has(item.ID)) return false;
    //                 seen.add(item.ID);
    //                 return true;
    //             });

    //             dipatch(employeeList(filterData));
    //         } else {
    //             dipatch(employeeList([]));
    //         }
    //     } catch (error) {
    //         dipatch(employeeList([]));
    //         console.error(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const getAllDepartment = async () => {
        try {
            // const response = await getRequest('getAllUser?departmentcode=5')
            const response = await getRequest(
                users?.ROLE_TITLE === "HR" ||
                    users?.ROLE_TITLE === "Admin" ||
                    users?.ROLE_TITLE === "Accountant"
                    ? "getAllDept"
                    : "getAllDept?departmentcode=5"
            );
            // console.log("response department", response)

            dipatch(depatmentList(response || []))
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        // if (users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant") {
        fetchAttendance()
        getAllDepartment()
        // }
    }, [])
    // console.log("allEmployee", allEmployee)
    return (
        <>
            {allEmployee?.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-screen py-16 w-full bg-gray-50 rounded-xl border border-dashed border-gray-300">
                    <div className="text-4xl mb-3">📭</div>
                    <p className="text-lg font-semibold text-gray-700">
                        No attendance data found
                    </p>
                    <p className="text-sm text-gray-500 mt-1 text-center">
                        There is no attendance record available for today.
                    </p>
                </div>
            ) : allEmployee?.length > 0 ? (
                <AttendanceTable empAttendance={allEmployee} />
            ) : (
                <Loader />
            )}

        </>
    )
}

export default TodayAttendence